import { AnalyticsConfig, PrivacyConfig } from '../types/AnalyticsTypes';

// Analytics configuration
export const analyticsConfig: AnalyticsConfig = {
  measurementId: process.env.REACT_APP_GA_MEASUREMENT_ID || '',
  enableInDevelopment: process.env.NODE_ENV === 'development' && 
                      process.env.REACT_APP_ENABLE_DEV_ANALYTICS === 'true',
  enableInProduction: process.env.NODE_ENV === 'production' &&
                     process.env.REACT_APP_ENABLE_ANALYTICS !== 'false',
  enableInTest: false, // Never enable analytics in tests
  batchEvents: process.env.NODE_ENV === 'production', // Batch in production only
  batchSize: 10,
  batchTimeout: 5000, // 5 seconds
  debugMode: process.env.REACT_APP_ANALYTICS_DEBUG === 'true'
};

// Privacy configuration
export const privacyConfig: PrivacyConfig = {
  anonymizeIP: true,
  respectDoNotTrack: true,
  enableUserOptOut: true,
  cookieConsent: false // Will be updated when cookie consent is implemented
};

// Validate analytics configuration
export const validateAnalyticsConfig = (config: AnalyticsConfig): boolean => {
  if (!config.measurementId) {
    console.warn('Analytics: No measurement ID provided');
    return false;
  }

  if (!config.measurementId.startsWith('G-')) {
    console.error('Analytics: Invalid measurement ID format');
    return false;
  }

  return true;
};

// Check if analytics should be enabled for current environment
export const shouldEnableAnalytics = (): boolean => {
  const config = analyticsConfig;
  
  switch (process.env.NODE_ENV) {
    case 'development':
      return config.enableInDevelopment;
    case 'production':
      return config.enableInProduction;
    case 'test':
      return config.enableInTest;
    default:
      return false;
  }
};

// Check if user has opted out of analytics
export const hasUserOptedOut = (): boolean => {
  if (!privacyConfig.enableUserOptOut) return false;
  
  try {
    return localStorage.getItem('analytics_opt_out') === 'true';
  } catch {
    return false;
  }
};

// Check Do Not Track preference
export const respectsDoNotTrack = (): boolean => {
  if (!privacyConfig.respectDoNotTrack) return false;
  
  return navigator.doNotTrack === '1' || 
         (window as any).doNotTrack === '1' ||
         (navigator as any).msDoNotTrack === '1';
};

// Overall check if analytics should run
export const canRunAnalytics = (): boolean => {
  if (!shouldEnableAnalytics()) return false;
  if (hasUserOptedOut()) return false;
  if (respectsDoNotTrack()) return false;
  if (!validateAnalyticsConfig(analyticsConfig)) return false;
  
  return true;
};